import {
  BORDER_STYLES,
  COLORS,
  COMMON_STYLES,
  LazyImage,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import React from 'react'
import { View, Text, StyleSheet } from 'react-native'

interface Props {
  cropName: string
  cropImageUrl: string
}

const CropCard2 = ({ cropImageUrl, cropName }: Props) => {
  return (
    <View
      style={[
        COMMON_STYLES.b1,
        BORDER_STYLES.borderNeutral20,
        COMMON_STYLES.br1,
        COMMON_STYLES['p1/2'],
        COMMON_STYLES['mt3/4'],
        COMMON_STYLES['mb3/2'],
        COMMON_STYLES.row,
        COMMON_STYLES.alignItemsCenter,
      ]}
    >
      <LazyImage
        imageUrl={cropImageUrl}
        imgStyles={styles.crpImage}
        fallBackIcon={
          <View style={[styles.crpImage, styles.noImage]}>
            <Text style={styles.noImgTextOverImg}>{cropName[0]}</Text>
          </View>
        }
      />
      <Text
        style={[
          TYPOGRAPHY.HEADING3,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral100,
          COMMON_STYLES['ml3/4'],
        ]}
      >
        {cropName}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  crpImage: {
    height: 64,
    width: 64,
    borderRadius: 32,
    borderWidth: 1,
    borderColor: COLORS.neutral10,
    zIndex: 1,
  },
  noImage: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.white,
  },
  noImgTextOverImg: {
    fontSize: 36,
    lineHeight: 40,
    fontWeight: '600',
    color: COLORS.black,
  },
})

export default CropCard2
